module.exports = __webpack_public_path__ + "static/media/blog02.e76b2c16.png";